var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_512_7717)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.4592 1.66031C12.3261 1.55642 12.1621 1.5 11.9932 1.5C11.8243 1.5 11.6603 1.55642 11.5272 1.66031L0.75 10.0645L1.68203 11.2433L3 10.2156V19.5C3.00081 19.8975 3.15911 20.2786 3.44024 20.5597C3.72137 20.8409 4.10242 20.9991 4.5 21H19.5C19.8976 20.9992 20.2787 20.841 20.5599 20.5598C20.841 20.2787 20.9993 19.8976 21 19.5V10.2225L22.318 11.25L23.25 10.0711L12.4592 1.66031ZM13.5 19.5H10.5V13.5H13.5V19.5ZM15 19.5V13.5C14.9995 13.1023 14.8414 12.721 14.5602 12.4398C14.279 12.1586 13.8977 12.0004 13.5 12H10.5C10.1023 12.0004 9.721 12.1585 9.43978 12.4397C9.15856 12.721 9.0004 13.1023 9 13.5V19.5H4.5V9.04608L12 3.20358L19.5 9.05396V19.5H15Z",
  fill: "currentColor"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_512_7717"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

var SvgHomeIcon = function SvgHomeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/HomeIcon.93a987e4.svg";
export { ForwardRef as ReactComponent };